import { RootState } from '@app/store/types';

export const getDocument = (state: RootState) => state.document;

export const isSendingToEmail = (state: RootState) => getDocument(state).isSendingToEmail;
